var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-3",attrs:{"fluid":"","tag":"section"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"3"}},[_c('v-card',{staticClass:"px-5 mt-15"},[_c('v-img',{attrs:{"src":require("@/assets/images/logo.png")}})],1),_c('framework-login',{staticClass:"py-5 text-center"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }